import React, { useState, useEffect} from 'react'
import { Container, Row, Col, Card,Form,
     Nav, NavItem, NavLink, Button } from 'react-bootstrap'
import PageTitle from "../common/PageTitle";
import { useTranslation } from "react-i18next";
import api from '../../api/api';
import moment from 'moment';
import WaterChart from './WaterChart';
import position from '../../assets/images/pin.png'
import soil from "../../assets/images/soil.png"
import crop from "../../assets/images/crop.png"
import swal from 'sweetalert';
import './WaterBalance.css';

const BilanHydrique = () => {
    const [isLoading,setIsLoading] = useState(false)
    const [toggle, setToggle] = useState(true)
    const [sumNbrIrrig, setSumNbrIrrig] = useState(0)
    const [sumIrrig, setSumIrrig] = useState(0)
    const [sumPluie, setSumPluie] = useState(0)
    const [sumETC, setSumETC] = useState(0)

    const [chartData, setChartData] = useState([])

    const [allVarieties, setAllVarieties] = useState([])

    const [elemValue, setElemValue] = useState('name')

    const [listCrop, setListCrop] = useState([])
    const [InputsData, setInputsData] = useState({
        Kc: "",
        ET0: "",
        surfaceIrrig: "",
        RUmax: "",
        Profondeur: "",
        effPluie: "",
        ruPratique: "",
        effIrrig: "",
        country: "",
        cities: [],
        city: "",
        cropType: "",
        cropVariety: [],
        variety: '',
        days: "",
        plantingDate: "",
        soilType: "",
        temperature: null,
        kcList: [],
        daysWeather: []

    })

    const [nameError, setNameError] = useState(null)
    const [cropError, setCropError] = useState(null)
    const [soilError, setSoilError] = useState(null)
    const [cityError, setCityError] = useState(null)
    const [error, setError] = useState(null)


    const [allSoils, setAllSoils] = useState([])
    const [allCountry, setAllCountry] = useState([])
    const [allCity, setAllCity] = useState([])


    const [dataSimulation,setDataSimulation] = useState({
        name : "",
        cityId :"",
        cropTypeId :"",
        soilTypeId :"",
        cropVarietyId :""
    })

    const { t } = useTranslation();

    let ETC = Number(InputsData.ET0) * Number(InputsData.Kc)
    let RuMax = Number(InputsData.RUmax) * Number(InputsData.Profondeur);
    let RuInitial = Number(InputsData.RUmax) * Number(InputsData.Profondeur);
    let Epuisement_maximal = (Number(InputsData.RUmax) * Number(InputsData.Profondeur) * Number(InputsData.ruPratique)) / 100
    let RuMin = Number(RuMax) - Number(Epuisement_maximal)
    let VolumeIrrigation = sumIrrig * 10
    let VolumeTotalEauIrrigation = Number(VolumeIrrigation) * Number(InputsData.surfaceIrrig)
    let Deficit = sumETC - sumPluie


    const getVarieties = async () => {
        try {
            await api.get('/varieties/get-varieties')
                .then(response => {
                    if (response.data.type === "success") {
                        let listVarieties = response.data.Varieties
                        setAllVarieties(listVarieties)

                    }
                }).catch(error => {
                    console.error(error)
                })

        } catch (error) {
            console.error(error)
        }
    }


    const getCitiesList = async () => {
        await api.get('/cities/list-cities')
            .then(response => {
                let cities = response.data.Cities
                if (response && response.data.type === "success") {
                    setAllCity(cities)
                }
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(() => {
        getCitiesList()

        const getCropType = async () => {
            try {
                await api.get('/croptype/list-crop')
                    .then(response => {
                        if (response) {
                            let dataCrop = response.data.Croptype
                            setListCrop(dataCrop)
                        }
                    })

            } catch (error) {
                console.error(error)
            }
        }
        const getSoils = async () => {
            try {
                await api.get('/soils/get-soils')
                    .then(response => {
                        let listSoils = response.data.Soils
                        setAllSoils(listSoils)
                        let Ru = ""
                        if (listSoils) {
                            listSoils.map(item => {
                                Ru = item.ru
                            })
                            setInputsData({ ...InputsData, RUmax: Ru })
                        }
                    }).catch(error => {
                        console.error(error)
                    })

            } catch (error) {
                console.error(error)
            }
        }
        const getCountries = async () => {
            try {
                await api.get('/countries/get-countries')
                    .then(response => {
                        if (response.data.type === "success") {
                            let listCountries = response.data.Countries
                            setAllCountry(listCountries)

                        }
                    }).catch(error => {
                        console.error(error)
                    })

            } catch (error) {
                console.error(error)
            }
        }
        getVarieties()
        getCountries()
        getSoils()
        getCropType()
    }, [])



    const handleSoilPick = (value) => {
        if(value){
            setDataSimulation({...dataSimulation , soilTypeId : value})
        }
        const soilType = allSoils.find(
            (soil) => soil.id == value
        );
        if (typeof soilType !== "undefined") {
            setInputsData({
                ...InputsData,
                soilType: soilType.soil,
                RUmax: soilType.ru,
                effIrrig: soilType.fc,
                ruPratique: soilType.practical_fraction,
                effPluie: soilType.rain_eff
            });

        }
    };

    const handleCropPick = (value) => {
        if(value){
            setDataSimulation({...dataSimulation , cropTypeId : value})
        }
        const crop = listCrop.find(
            (crop) => crop.id == value
        );
        let varieties = []
        if (crop) {
            const variety = allVarieties.map((variety) => {
                if (variety.crop_id === crop.id) {
                    varieties.push({
                        variety: variety.crop_variety
                    })
                }

            });
            setInputsData({
                ...InputsData,
                cropType: crop.crop,
                variety: '',
                cropVariety: varieties,
                Profondeur: crop.root_max,
                days: crop.total,
                plantingDate: crop.plant_date.slice(0, 11).replace('T', ''),
                kcList: crop.all_kc
            });

        }
    };

    const handleVarietyPick = (e) => {
        e.preventDefault();
        const variety = allVarieties.find(
            (variety) => variety.crop_variety === e.target.value

        )
        if (variety) {
            setInputsData({
                ...InputsData,
                cropType: "",
                variety: variety.crop_variety,
                Profondeur: variety.root_max,
                days: variety.total,
                plantingDate: variety.plant_date.slice(0, 11).replace('T', ''),
                kcList: variety.all_kc
            });
        }
    };


    const handleCountryPick = (e) => {
        e.preventDefault();
        const country = allCountry.find(
            (country) => country.iso === e.target.value
        );
        let cities = []
        if (country) {
            const city = allCity.map((city) => {
                if (city.iso === country.iso) {
                    cities.push({
                        city: city.city,
                        id : city.id
                    })
                }

            });

            setInputsData({
                ...InputsData,
                country: country.iso,
                cities: cities
            });

        }

    };


    const isValidInputs = () => {
        let cityError = ""
        let nameError = ""
        let cropError = ""
        let soilError = ""
        let error= ''
        if (dataSimulation.cityId === "") {
            cityError = `${t('city_error')}`;
            error= `${t('city_error')}`

            setCityError(cityError)
            setError(error)
        }
        if (dataSimulation.name === "") {
            nameError = `${t('name_error')}`;
            error= `${t('name_error')}`
            setNameError(nameError)
            setError(error)

        }
        if (InputsData.cropType === "") {
            cropError = `${t('croptype_error')}`;
            error= `${t('croptype_error')}`
            setCropError(cropError)
            setError(error)

        }
        if (InputsData.soilType ==="") {
            soilError = `${t('soiltype_error')}`;
            error= `${t('soiltype_error')}`
            setSoilError(soilError)
            setError(error)

        }
        if(soilError || cropError || cityError || nameError){
            setSoilError(soilError)
            setCropError(cropError)
            setNameError(nameError)
            setCityError(cityError)
            setError(error)
            return false;

        }else{
            setSoilError('')
            setCropError('')
            setNameError('')
            setCityError('')
            setError('')
        }
        
         return true;
    }
    const returnInputs = () => {
        switch (elemValue) {
            case "name":
                return (

                    <Form.Group>
                        <label htmlFor="name">{t('name')}</label>
                        <Form.Control id="name" placeholder={t('name')} value={dataSimulation.name} className={`form-control form-control-md ${nameError ? "is-invalid" : ""}`}  onChange={(e) => setDataSimulation({...dataSimulation , name : e.target.value})} />
                    </Form.Group>

                )
            case "pos":
                return (
                    <Row form  className='gap-2'>

                        <Col className="py-4" lg="6" md="8" sm="8">
                            <Form.Group>

                                <label htmlFor="country">{t('state')}</label>
                                <Form.Select id="country" value={InputsData.country || ''} onChange={handleCountryPick}>

                                    <option value=''>{t('select_country')}</option>

                                    {
                                        allCountry.map(country => (
                                            <option key={country.id} value={country.iso}>{country.name}</option>
                                        ))
                                    }

                                </Form.Select>

                            </Form.Group>
                        </Col>
                        <Col className="py-4" lg="5" md="8" sm="8">
                            <Form.Group>

                                <label htmlFor="city">{t('city')}</label>
                                <Form.Select className={`form-control form-control-md ${cityError ? "is-invalid" : ""}`} value={dataSimulation.cityId || ""} onChange={e => setDataSimulation({ ...dataSimulation, cityId: e.target.value })} id="city" style={{height:"40px"}}>
                                    <option value="">{t('select_city')}</option>
                                    {
                                        InputsData.cities.map(city => {
                                            return (
                                                <option key={city.id} value={city.id}>{city.city}</option>
                                            )
                                        })
                                    }

                                </Form.Select>

                            </Form.Group>

                        </Col>


                    </Row>

                )
            case "crop":
                return (
                    <Row form className="py-2 m-2 gap-2">
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="cropType">{t('crop_type')}</label>
                                <Form.Select className={`form-control form-control-md ${cropError ? "is-invalid" : ""}`} id="cropType" value={dataSimulation.cropTypeId || ""} onChange={(e) => handleCropPick(e.target.value)}>
                                    <option value="">{t('select_crop')}</option>
                                    {
                                        listCrop.map(cropType => (
                                            <option style={{ textTransform: "capitalize" }} key={cropType.id} value={cropType.id}>{cropType.crop}</option>

                                        ))
                                    }

                                </Form.Select>

                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="cropVariety">{t('crop_variety')}</label>
                                <Form.Select value={InputsData.variety || ""} onChange={handleVarietyPick} id="cropVariety">
                                    <option value="">{t('crop_type')}</option>
                                    {
                                        InputsData.cropVariety.map(variety => (
                                            <option key={variety.variety} value={variety.variety}>{variety.variety}</option>
                                        ))
                                    }
                                </Form.Select>
                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="ruPratique">{t('fraction_pratique')} (%) </label>
                                <Form.Control value={InputsData.ruPratique || ''} onChange={e => setInputsData({ ...InputsData, ruPratique: e.target.value })} id='ruPratique' placeholder={t('fraction_pratique')} 
                                />
                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="z">{t('depth')} (m)</label>
                                <Form.Control value={InputsData.Profondeur || ''} onChange={e => setInputsData({ ...InputsData, Profondeur: e.target.value })} id='z' placeholder={t('profondeur')}
                                />

                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="days">{t('Days')}</label>

                                <Form.Control value={InputsData.days || ""} id='days' onChange={e => setInputsData({ ...InputsData, days: e.target.value })} placeholder={t('Days')} />

                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="days">{t('growing_season')}</label>

                                <Form.Control type="date" value={InputsData.plantingDate || ""} onChange={e => setInputsData({ ...InputsData, plantingDate: e.target.value })} id='days' />

                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="ecartInter">{t('ecart_inter')} (m)</label>
                                <Form.Control disabled title={t('field_not_available_yet')} value="" id='ecartInter' placeholder={t('field_not_available_yet')}
                                />
                            </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                        <Form.Group>
                            <label htmlFor="ecartIntra">{t('ecart_intra')} (m) </label>
                            <Form.Control disabled title={t('field_not_available_yet')} value="" id='ecartIntra' placeholder={t('field_not_available_yet')}
                            />
                        </Form.Group>

                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="densité">{t('densité')} (plants/ha)</label>
                                <Form.Control disabled title={t('field_not_available_yet')} value="" id='densité' placeholder={t('field_not_available_yet')}
                                />
                            </Form.Group>

                        </Col>
                    </Row>

                )
            case "soil":
                return (
                    <Row form className="py-2 m-2 gap-2">
                        <Col lg="4" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="soil">{t('soil_type')}</label>
                                <Form.Select className={`form-control form-control-md ${soilError ? "is-invalid" : ""}`} value={dataSimulation.soilTypeId} id="soil" onChange={(e) => handleSoilPick(e.target.value)}>
                                    <option value=''>{t('select_soil')}</option>
                                    {
                                        allSoils.map(soil => {
                                            
                                            return (
                                                <option key={soil.id} value={soil.id}>{soil.soil}</option>
                                            )
                                        })
                                    }
                                </Form.Select>

                            </Form.Group>

                        </Col>
                        <Col lg="4" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="effPluie">{t('efficacité_pluie')} (%)</label>
                                <Form.Control value={InputsData.effPluie || ''} onChange={e => setInputsData({ ...InputsData, effPluie: e.target.value })} id='effPluie' placeholder={t('efficacité_pluie')} 
                                />

                            </Form.Group>
                        </Col>
                        <Col lg="3" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="ruMax">RU max (mm/m)</label>
                                <Form.Control value={InputsData.RUmax || ''} onChange={e => setInputsData({ ...InputsData, RUmax: e.target.value })} id='ruMax' placeholder="RU max"
                                />

                            </Form.Group>

                        </Col>
                    </Row>
                )
            case "irrig":
                    return (
                        <Row form className="py-2 m-2 gap-2">
                             <Col lg="6" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="surfaceIrrig">{t('surface_irriguée')} (ha)</label>
                                <Form.Control value={InputsData.surfaceIrrig || ''} onChange={e => setInputsData({ ...InputsData, surfaceIrrig: e.target.value })} id="surfaceIrrig" placeholder={t('surface_irriguée')}
                                />


                            </Form.Group>

                        </Col>
                        <Col lg="5" md="8" sm="8">
                            <Form.Group>
                                <label htmlFor="effIrrig">{t('efficience_irrigation')} (%) </label>
                                <Form.Control value={InputsData.effIrrig || ''} onChange={e => setInputsData({ ...InputsData, effIrrig: e.target.value })} id='effIrrig' placeholder={t('efficience_irrigation')} 
                                />

                            </Form.Group>

                        </Col>

                        </Row>
                    )

            default:
                return (
                    <Row form className='gap-2' >
                        <Col lg="6" md="8" sm="8">
                            <Form.Group>

                                <label htmlFor="country">{t('state')}</label>
                                <Form.Select id="country" value={InputsData.country || ''} onChange={handleCountryPick}>

                                    <option value=''>{t('select_country')}</option>

                                    {
                                        allCountry.map(country => (
                                            <option key={country.id} value={country.iso}>{country.name}</option>
                                        ))
                                    }

                                </Form.Select>

                            </Form.Group>
                        </Col>
                        <Col lg="5" md="8" sm="8">
                            <Form.Group>

                                <label htmlFor="city">{t('city')}</label>
                                <Form.Select value={InputsData.city || ""} onChange={e => setInputsData({ ...InputsData, city: e.target.value })} id="city">
                                    <option value="">{t('select_city')}</option>
                                    {
                                        InputsData.cities.map(city => {
                                            return (
                                                <option key={city.city} value={city.city}>{city.city}</option>
                                            )
                                        })
                                    }

                                </Form.Select>
                            </Form.Group>

                        </Col>

                    </Row>)
        }

    }

    const imageByInputs = () => {
        switch (elemValue) {
            case "pos":
                return <img
                    className="rounded-circle h-100"
                    width="140"
                    src={position}
                />
            case "crop":
                return <img
                    className="rounded-circle h-100"
                    width="140"
                    src={crop}
                />
            case "soil":
                return <img
                    className="rounded-circle h-100"
                    width="140"
                    src={soil}
                />
            default:
                return <img
                    className="rounded-circle h-100"
                    width="140"
                    src={position}
                />
        }
    }

        const [simulation,setSimulation] = useState([])
   
    const checkAndSave = () => {
        const isValid = isValidInputs()
        if (!isValid) {
            return
        }
        let data = {
            name : dataSimulation.name,
            city_id : dataSimulation.cityId,
            croptype_id : dataSimulation.cropTypeId,
            soiltype_id :dataSimulation.soilTypeId,
            cropvariety_id : dataSimulation.cropVarietyId,
            inputs : InputsData
        }
            api.post('/simulation/calcul-simulation',data)
            .then(response=>{
                    let simulationResult = response.data.simulation
                    if(response.data.type === "success") {
                        setSimulation(simulationResult.result)
                        setSumETC(response.data.sumETC)
                        setSumIrrig(response.data.sumIrrig)
                        setSumNbrIrrig(response.data.sumNbrIrrig)
                        swal({
                            icon: 'info',
                            title: t('ok'),
                            text: `${t('saved_simulation')}`
                          })

                    }
                    if(response.data.type === "danger"){
                        swal({
                            icon: 'error',
                            text: response.data.message
                          })
                    }
            }).catch(error=>{
                console.error(error)
            }).finally(() => setIsLoading(true) )


    }

    useEffect(() => {
        let data = []
        let sumRain = 0

        simulation.map(result=>{
            if(result){
                sumRain = sumRain + Number(result.rain)
                data.push({
                   bilan: result.bilan,
                    dates :result.date
                })
            }
        })
        setChartData(data)
        setSumPluie(sumRain)
    }, [simulation])


    return (
        <Container fluid className="main-content-container water-balance-page p-4">
            <Row noGutters className="page-header py-4">
                <PageTitle
                    sm="4"
                    title={t('water_balance')}
                    subtitle={t('overview')}
                    className="text-sm-left"
                />
            </Row>
            <Row className='text-center my-2'>
                <Col lg='12' md="12" sm="12">
                    <Card>
                        <Card.Header className="border-bottom d-flex justify-content-between align-items-center">
                                <h6 className="m-0">{t('config')}</h6>
                                <div>
                                    <i className='material-icons'>&#xe88e;</i> <span style={{fontSize :13,textDecoration:"underline"}}>{t('msg_simulation_name')}</span>
                                </div>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col lg='4' md="12" sm="12" className="border-right d-flex justify-content-center align-items-center">
                                    <div className="mb-3 mx-auto" style={{ height: "140px" }}>
                                        {imageByInputs()}
                                    </div>
                                </Col>
                                <Col lg='8' md="12" sm="12">
                                    <Row form className="py-2 m-2" >
                                        <Col lg="12" md="8" sm="8" className='py-4'>
                                           {error && <div className="wb-error mb-2">{error}</div>}
                                            <Nav tabs style={{ paddingBottom: 10 }}>
                                            <NavItem>
                                                    <NavLink onClick={(e) => setElemValue(e.target.id)} id="name" className={`${elemValue === "name" ? "bg-info rounded text-dark" : 'rounded text-dark'}`} href="#">
                                                    {t('name')}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={(e) => setElemValue(e.target.id)} id="pos" className={`${elemValue === "pos" ? "bg-info rounded text-dark" : 'rounded text-dark'}`} href="#">
                                                        {t('position')}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={(e) => setElemValue(e.target.id)} id="crop" className={`${elemValue === "crop" ? "bg-info rounded text-dark" : 'rounded text-dark'}`} href="#">{t('crop_info')}</NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={(e) => setElemValue(e.target.id)} id="soil" className={`${elemValue === "soil" ? "bg-info rounded text-dark" : 'rounded text-dark'}`} href="#">{t('soil_info')}</NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={(e) => setElemValue(e.target.id)} id="irrig" className={`${elemValue === "irrig" ? "bg-info rounded text-dark" : 'rounded text-dark'}`} href="#">{t('Irrigation')}</NavLink>
                                                </NavItem>
                                            </Nav>
                                        </Col>

                                        {returnInputs()}
                                    </Row>
                                    {
                                        elemValue === "soil"
                                            ?
                                            <Row className="d-flex justify-content-center align-items-center">
                                               
                                                    <Button variant="success" onClick={() => checkAndSave()} >{t('save')}</Button>

                                            </Row>
                                            :
                                            null
                                    }
                                </Col>

                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg='12' md="12" sm="12">
                    <Card>
                        <Card.Header className="border-bottom">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    width: "auto",
                                    float: "left"
                                }}
                            >
                                <h6 className="m-0">{t('outputs')}</h6>{" "}
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Row className='gap-2'>
                                <Col id="page" lg="3" md="8" sm="8" className="form-group ">
                                    <label htmlFor="ruMax">RU max (mm)</label>
                                    <Form.Control id="ruMax" value={RuMax} placeholder="RU max" readOnly />
                                </Col>
                                <Col lg="2" md="8" sm="8" className="form-group">
                                    <label htmlFor="ruInit">{t('ru_initiale')} (mm)</label>
                                    <Form.Control id='ruInit' value={RuInitial} placeholder="RU initiale" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="epuis">{t('epuisement_max')} (mm)</label>
                                    <Form.Control id="epuis" value={Epuisement_maximal} placeholder="Epuisement maximal" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="nbrIrrig">{t('nbr_irrigations')}</label>

                                    <Form.Control id='nbrIrrig' value={sumNbrIrrig} placeholder="Nombre d'irrigations" readOnly />
                                </Col>
                                <Col lg="2" md="8" sm="8" className="form-group">
                                    <label htmlFor="hautIrrig">{t('hauteur_irrigations')} (mm)</label>
                                    <Form.Control id='hautIrrig' value={parseFloat(sumIrrig).toFixed(0)} placeholder="Hauteur d'eau des irrigations" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="vIrrig">{t('volume_irrigations')} (m³ /ha)</label>
                                    <Form.Control value={parseFloat(VolumeIrrigation).toFixed(0)} id="vIrrig" placeholder="Volume des irrigations" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="rumin">Ru Min (mm)</label>
                                    <Form.Control value={RuMin} id="rumin" placeholder="RU min" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="volTotalIrrig">{t('Volume_total_irrigation')} (m³)</label>
                                    <Form.Control value={parseFloat(VolumeTotalEauIrrigation).toFixed(0)} id="volTotalIrrig" placeholder="Volume Total d'eau d'irrigation" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="pluieTotal">{t('pluie_total')} (mm)</label>
                                    <Form.Control value={parseFloat(sumPluie).toFixed(0)} id="pluieTotal" placeholder="Pluie total" readOnly />
                                </Col>
                                <Col lg="3" md="8" sm="8" className="form-group">
                                    <label htmlFor="evoTotal">{t('evapotranspiration_totale')} (mm)</label>
                                    <Form.Control value={parseFloat(sumETC).toFixed(0)} id='evoTotal' placeholder="Evapotranspiration totale" readOnly />
                                </Col>

                                <Col lg="3" md="8" sm="8" >
                                    <label htmlFor="deficit">{t('déficit')} (mm)</label>
                                    <Form.Control value={parseFloat(Deficit).toFixed(0)} id="deficit" placeholder="Déficit" readOnly />
                                </Col>
                            </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="py-2 d-flex justify-content-center align-items-center text-center">

                    <Col>
                    <Card>
                        {
                         isLoading

                            ?
                            <Card.Body>
                                <p className="py-2 d-flex justify-content-center align-items-center wb-toggle-buttons">
                                    <button type="button" aria-label={t('view_table')} title={t('view_table')} aria-pressed={toggle} style={{ fontSize: 30, margin: 8, border: "1px solid var(--sf-night-border, #eee)", borderRadius: 10, background: 'none' }} onClick={() => setToggle(true)}><i className='material-icons' aria-hidden="true">&#xe265;</i></button>
                                    <button type="button" aria-label={t('view_chart')} title={t('view_chart')} aria-pressed={!toggle} style={{ fontSize: 30, margin: 8, border: "1px solid var(--sf-night-border, #eee)", borderRadius: 10, background: 'none' }} onClick={() => setToggle(false)}><i className='material-icons' aria-hidden="true">&#xe6e1;</i></button>
                                </p>

                                <Col className={`${toggle ? '' : 'd-none'}`} lg="12" md="12" sm="12">
                                    <h6>{t('water_balance')}</h6>
                                    <table className="table mb-0 text-center table-bordered table-hover table-responsive-lg">
                                        <thead className="bg-light">
                                            <tr>
                                                <th scope="col" className="border-0">{t('Days')}</th>
                                                <th scope="col" className="border-0">{t('Dates')}</th>
                                                <th scope="col" className="border-0">{t('Kc')}</th>
                                                <th scope="col" className="border-0">{t('ET0')}</th>
                                                <th scope="col" className="border-0">{t('Pluie')} (mm)</th>
                                                <th scope="col" className="border-0">{t('ETc')}</th>
                                                <th scope="col" className="border-0">{t('Pe')} (mm)</th>
                                                <th scope="col" className="border-0">{t('Bilan hydrique')} (mm)</th>
                                                <th scope="col" className="border-0">{t('Irrigation')}</th>
                                                <th scope="col" className="border-0">{t('Nbr Irrigation')}</th>
                                            </tr>
                                        </thead>
                                        {
                                            simulation.map((result, index) => {
                                                let dates = moment(result.date.slice(0,10)).locale('En').format('MMM DD')
                                                let ET0 = 2
                                                return(
                                                    <tbody key={result.date || index}>
                                                        <tr>
                                                            <td>{result.days}</td>
                                                            <td>{dates}</td>
                                                            <td>{parseFloat(result.kc).toFixed(2)}</td>
                                                            <td>{ET0}</td>
                                                            <td>{result.rain}</td>
                                                            <td>{parseFloat(result.Etc).toFixed(2)}</td>
                                                            <td>{parseFloat(result.pe).toFixed(2)}</td>
                                                            <td>{parseFloat(result.bilan).toFixed(2)}</td>
                                                            <td>{parseFloat(result.irrigation).toFixed(2)}</td>
                                                            <td>{result.irrigationNbr}</td>
                                                        </tr>
                                                    </tbody>

                                                )
                                            })
                                        }
                                    </table>
                                </Col>
                                <Col className={`${toggle ? 'd-none' : ''}`} lg="12" md="8" sm="8">
                                    <h6>{t('water_balance_chart')}</h6>
                                    <WaterChart data={chartData} />
                                </Col>

                            </Card.Body>
                            :
                            null

                        }
                    </Card>
                    </Col>
                        
                    

            </Row>



        </Container>
    )
}

export default BilanHydrique
